import Vue from 'vue'
import { Mixin } from 'vue-mixin-decorator'

@Mixin
export default class CompanyInfoMixin extends Vue {
    isNorwegionCompany(nationality: string) {
        return nationality.toLowerCase() === 'nor'
    }

    isSwedishCompany(nationality: string) {
        return nationality?.toLowerCase() === 'swe'
    }

    formatOrgNumber(orgNo: string | number, nationality: string) {
        if (this.isNorwegionCompany(nationality)) {
            return orgNo.toString().replace(/(\d{3})(\d{3})(\d{3})/, '$1 $2 $3')
        }

        return orgNo
    }
}
